export default __webpack_public_path__ + "static/media/calendar-padded.121134dd.svg";